import { formatCurrencyFromMicros, formatDecimal, formatInteger } from '../constants';

const CARD_CONFIG = [
  { key: 'spendMicros', label: 'Spend', format: formatCurrencyFromMicros },
  { key: 'impressions', label: 'Impressions', format: formatInteger },
  { key: 'clicks', label: 'Clicks', format: formatInteger },
  { key: 'conversions', label: 'Conversions', format: formatDecimal },
];

export function SummaryCards({ summary }) {
  return (
    <section className="grid gap-4 md:grid-cols-2 xl:grid-cols-4" aria-label="Ad performance summary">
      {CARD_CONFIG.map(({ key, label, format }) => (
        <article key={key} className="rounded-2xl border border-mystic-500 bg-white p-5 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-lynch-500">{label}</p>
          <p className="mt-3 text-2xl font-semibold text-black-pearl-500">{format(summary?.[key])}</p>
        </article>
      ))}
    </section>
  );
}
